import React from 'react'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { debounce, get } from 'lodash'
import { toastr } from 'react-redux-toastr'
import { Link } from 'react-router-dom'
import { ButtonGroup } from 'react-bootstrap'
import styledComponents from 'styled-components'
import moment from 'moment'

import {
  fetchReservations,
  deleteReservation,
  confirmReservation,
} from '../../actions/fetch_reservation'
import { AllReservationTable } from './ReservationTable'
import { withAlertModal } from '../alertModal'
import { showAlert, hideAlert } from '../../actions/alert'
import { createQueryFilter } from './createQueryFilter'
import DateRangeSelector from '../commons/DateRangeSelector'
import { createDateRangeQuery } from '../../utils/dateRangeUtils'

class ReservationTableContainer extends React.Component {
  selectedReservations = {}
  abortController = null

  state = {
    selectionMode: 'day', // 'day' or 'month'
    selectedDate: moment(),
    year: moment().year(),
    month: moment().month(),
    filter: null,
  }

  componentDidMount() {
    this.handleDataChange = debounce(this.handleDataChange, 1000)
  }

  componentWillUnmount() {
    this.abortInFlights()
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.isPrimaryTriggered &&
      nextProps.alertMeta &&
      nextProps.alertMeta.reservationsToConfirm
    ) {
      const reservationsToConfirm = nextProps.alertMeta.reservationsToConfirm
      reservationsToConfirm.forEach((r) => {
        this.props.confirmReservation(r.id, { fetchId: 'reservation' })
      })
      this.props.hideAlert()
      toastr.success('Confirm success')
    }
  }

  abortInFlights() {
    if (this.abortController) {
      this.abortController.abort()
      this.abortController = undefined
    }
  }

  handleSelectionModeChange = (mode) => {
    this.setState({ selectionMode: mode }, () => {
      // Trigger data refetch with updated selection mode
      if (this.state.filter) {
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleDateChange = (date) => {
    this.setState({ selectedDate: date }, () => {
      // Trigger data refetch with updated date
      if (this.state.filter) {
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleMonthChange = (field, value) => {
    this.setState({ [field]: value }, () => {
      if (this.state.filter) {
        // Use saved filter from state
        this.handleDataChange(this.state.filter)
      }
    })
  }

  handleDataChange = (filter) => {
    // Save filter to state
    this.setState({ filter })

    // Cancel previous request
    this.abortInFlights()

    // Create new controller for this request
    this.abortController = new AbortController()

    const baseQuery = createQueryFilter(filter.query) || {}

    // // Add date range query based on selection mode
    // const dateRangeQuery = createDateRangeQuery(
    //   this.state.selectionMode,
    //   this.state.selectedDate,
    //   this.state.year,
    //   this.state.month,
    // )
    // Object.assign(baseQuery, dateRangeQuery)

    this.props.fetchReservations(
      {
        page: filter.currentPage,
        limit: filter.sizePerPage,
        sort: filter.sort,
        order: filter.order,
        createByKiosk: false,
        ...baseQuery,
      },
      {
        signal: this.abortController.signal,
      },
    )
  }

  onReservationSelect = (reservation, value) => {
    this.selectedReservations = {
      ...this.selectedReservations,
      [reservation.id]: value ? reservation : undefined,
    }
  }

  onReservationSelectAll = (value) => {
    if (value) {
      this.selectedReservations = this.props.instances.reduce(
        (obj, r) => ({ ...obj, [r.id]: r }),
        {},
      )
    } else {
      this.selectedReservations = {}
    }
  }

  handleConfirmReservation = () => {
    const selectedReservations = this.getSelectedReservations()
    this.showConfirmReservationAlert(selectedReservations)
  }

  showConfirmReservationAlert = (selectedReservations) => {
    const reservationsToConfirm = selectedReservations.reduce(
      (list, r) => (r.status === 'tentative' ? [...list, r] : list),
      [],
    )

    if (reservationsToConfirm.length)
      this.props.showAlert(
        {
          header: 'Confirm Reservations',
          description: `Are you sure to confirm reservation ${
            reservationsToConfirm.length
          }/${selectedReservations.length}`,
          primary: {
            title: 'Confirm',
            bsStyle: 'primary',
          },
          defaultCancelButton: true,
        },
        { reservationsToConfirm },
      )
  }

  getSelectedReservations = () => {
    const reservations = []
    for (const id in this.selectedReservations) {
      const reservation = (this.props.instances || []).find((r) => r._id === id)
      if (reservation) reservations.push(reservation)
    }
    return reservations
  }

  tableSettings = {
    selectRow: undefined,
  }

  customRenderToolbar = (defaultFilterButton) => {
    return (
      <div className="pull-right flex gap-2 items-center">
        {/* <DateRangeSelector */}
        {/*   selectionMode={this.state.selectionMode} */}
        {/*   selectedDate={this.state.selectedDate} */}
        {/*   year={this.state.year} */}
        {/*   month={this.state.month} */}
        {/*   onSelectionModeChange={this.handleSelectionModeChange} */}
        {/*   onDateChange={this.handleDateChange} */}
        {/*   onMonthChange={this.handleMonthChange} */}
        {/* /> */}
        {defaultFilterButton}
      </div>
    )
  }

  render() {
    return (
      <AllReservationTable
        {...this.props}
        onDataChange={this.handleDataChange}
        defaultSortName="log.lastUpdatedDateTime"
        defaultSortOrder="desc"
        onConfirm={this.handleReservationConfirm}
        options={{
          btnGroup: createButtonGroup(
            this.props.path,
            this.handleConfirmReservation,
          ),
        }}
        settings={this.tableSettings}
        customRenderToolbar={this.customRenderToolbar}
      />
    )
  }
}

const createButtonGroup = (path, onConfirmReservation) => (props) => {
  return (
    <ButtonGroup>
      <InsertButton to={`${path}/new`}>
        <i className="glyphicon glyphicon-plus" />{' '}
        {I18n.t('action.add').toUpperCase()}
      </InsertButton>
    </ButtonGroup>
  )
}

const InsertButton = styledComponents(Link).attrs({
  className: 'btn btn-info',
})`
`

export default connect(
  ({ fetch, auth }) => ({
    isLoading: get(fetch, 'reservation.isLoading.list', false),
    instances: get(fetch, 'reservation.list', []),
    totalCount: get(fetch, 'reservation.totalCount'),
    auth,
  }),
  {
    fetchReservations,
    deleteInstance: deleteReservation,
    confirmReservation,
    showAlert,
    hideAlert,
  },
)(withAlertModal(ReservationTableContainer))
